/*
  Pre-landing and offer actions (preview, open, file editor).
  Merged FIRST into TRANSLATION_MAPS in ./index.js, so existing translations
  still win. Keys are the English source.
*/

const ru = {
  "Open pre-landing": "Открыть пре-лендинг",
  "Open offer": "Открыть оффер",
  "Start page": "Стартовая страница",
  "Not saved": "Не сохранено",
};

const es = {
  "Open pre-landing": "Abrir pre-landing",
  "Open offer": "Abrir oferta",
  "Start page": "Página de inicio",
  "Not saved": "Sin guardar",
};

const pt = {
  "Open pre-landing": "Abrir pre-landing",
  "Open offer": "Abrir oferta",
  "Start page": "Página inicial",
  "Not saved": "Não salvo",
};

const de = {
  "Open pre-landing": "Prelander öffnen",
  "Open offer": "Offer öffnen",
  "Start page": "Startseite",
  "Not saved": "Nicht gespeichert",
};

const fr = {
  "Open pre-landing": "Ouvrir le prelander",
  "Open offer": "Ouvrir l’offre",
  "Start page": "Page de départ",
  "Not saved": "Non enregistré",
};

const it = {
  "Open pre-landing": "Apri prelander",
  "Open offer": "Apri offerta",
  "Start page": "Pagina iniziale",
  "Not saved": "Non salvato",
};

const pl = {
  "Open pre-landing": "Otwórz prelander",
  "Open offer": "Otwórz ofertę",
  "Start page": "Strona startowa",
  "Not saved": "Nie zapisano",
};

const tr = {
  "Open pre-landing": "Pre-landing'i aç",
  "Open offer": "Teklifi aç",
  "Start page": "Başlangıç sayfası",
  "Not saved": "Kaydedilmedi",
};

const uk = {
  "Open pre-landing": "Відкрити прелендинг",
  "Open offer": "Відкрити офер",
  "Start page": "Стартова сторінка",
  "Not saved": "Не збережено",
};

const BUNDLE_ACTIONS = { ru, es, pt, de, fr, it, pl, tr, uk };

export default BUNDLE_ACTIONS;
